import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import {
  getLoginUserDetails,
  isOnboardingCompleteFromUser,
} from '../utils/onboarding.util';
import { getEssDashboardRoute } from 'src/app/environments/environment-host';
import { PolicyConsentService } from 'src/app/policy-consent/policy-consent.service';

@Injectable({ providedIn: 'root' })
export class OnboardingAccessGuard {
  constructor(
    private router: Router,
    private policyConsentService: PolicyConsentService
  ) {}

  canActivate(): boolean | UrlTree | Observable<boolean | UrlTree> {
    const user = getLoginUserDetails();
    if (!user) {
      return this.router.createUrlTree(['/auth/login']);
    }
    if (!isOnboardingCompleteFromUser(user)) {
      return true;
    }

    return this.policyConsentService.hasPendingConsent().pipe(
      map((hasPending) =>
        this.router.createUrlTree(
          hasPending ? ['/policy-consent'] : getEssDashboardRoute()
        )
      ),
      catchError(() => of(this.router.createUrlTree(getEssDashboardRoute())))
    );
  }
}
